import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const LeadsPage = lazy(() => import('./LeadsPage'));

const LeadsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Sales,
  routes: [
    {
      path: 'leads',
      element: <LeadsPage />,
    },
  ],
};

export default LeadsConfig;
